import React, { useCallback, useState, memo } from 'react';
import { Select } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ClientCustomCalendarModel, ReportCurrency } from '../../../models';
import * as Styled from './styled';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingLeaseCommitmentProps {
  onChange: (updatedValue: ReportSettingLeaseCommitmentState) => void;
  reportSettingState: ReportSettingLeaseCommitmentState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowPIT: boolean;
}

export interface ReportSettingLeaseCommitmentState {
  selectedCurrency: SelectOption<ReportCurrency>;
  shortStartDate: string;
  shortEndDate: string;
  selectedEndDateOption: string;
  isValid: boolean;
}

function ReportSettingCommitment({
  onChange,
  reportSettingState,
}: ReportSettingLeaseCommitmentProps): JSX.Element {
  const [isDateRangeValid, setDateRangeValidStatus] = useState(false);
  const inputHandler = useCallback(
    (state: ReportSettingLeaseCommitmentState) => {
      const { isValid } = state;
      let isValidInput = isDateRangeValid;
      if (isValid !== undefined) {
        isValidInput = isValid;
        setDateRangeValidStatus(isValid);
      }

      onChange({
        ...state,
        isValid: isValidInput,
      });
    },
    [isDateRangeValid, onChange],
  );
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                inputHandler({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [inputHandler, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingCommitment);
